export default "__VITE_ASSET__a7d2be54__"